<template>
  <eg-modal
    id="trial-ended-modal"
    size="medium"
    centered
    :closable="true"
    :title="$t('dashboard.trial.trialEndedTitle')"
    @onClose="closeModal"
  >
    <template #header="{ close }">
      <eg-modal-header
        :title="$t('dashboard.trial.trialEndedTitle')"
        closable
        @onClose="close"
      >
        <template #title="{ title }">
          <div class="d-flex flex-column">
            <h3 class="semi-bold eg-modal__title">{{ title }}</h3>
            <div class="header-subtitle paragraph-s">
              {{ $t("dashboard.trial.youHaveGraded") }}
              {{ accountProvider.usage?.essaysUsage?.count || 0 }}
              {{ $t("dashboard.trial.essaysAndSaved") }}
              {{ formatTimeSaved(accountProvider.usage?.savings?.time || 0) }}
            </div>
          </div>
        </template>
      </eg-modal-header>
    </template>
    <div class="trial-ended-modal">
      <ul class="trial-features-list">
        <li
          v-for="(value, index) in trialEndFeaturesList"
          :key="index"
          class="trial-feature-item paragraph-m"
        >
          <eg-icon icon="check-circle" size="medium" color="#9333ea" />
          <span>{{ value }}</span>
        </li>
      </ul>

      <div class="trial-ended-footer">
        <div class="discount-subscription paragraph-s">
          {{ $t("dashboard.trial.save30Percent") }}
        </div>
        <eg-button
          type="primary"
          icon="stars"
          size="lg"
          icon-size="medium"
          class="upgrade-button"
          @click="upgradeNow"
        >
          {{ $t("dashboard.trial.upgradeNow") }}
        </eg-button>
      </div>
    </div>
  </eg-modal>
</template>

<script>
import { defineComponent } from "vue";
import UpgradePlanModal from "@/components/global/modals/upgrade_plan_modal.vue";
import EgModalHeader from "@/components/global/eg/modals/eg_modal_header";
import { formatTimeSaved } from "@/utils/format";

export default defineComponent({
  name: "TrialEndedModal",
  components: { EgModalHeader },
  inject: ["accountProvider"],
  computed: {
    trialEndFeaturesList() {
      return this.$store.getters.trialEndFeaturesList;
    },
  },
  methods: {
    formatTimeSaved,
    async upgradeNow() {
      this.$egModal.show("upgrade-plan-modal", {
        component: UpgradePlanModal,
      });
    },
    closeModal() {
      this.$egModal.hide("trial-ended-modal");
    },
  },
});
</script>

<style scoped lang="scss">
#trial-ended-modal {
  .eg-modal__title {
    margin-bottom: 0.5rem;
  }
  .eg-modal__header {
    align-items: start !important;
  }
  .header-subtitle {
    color: var(--color-text-neutral-secondary, #566370);
    margin: 0;
  }
}

.trial-features-list {
  display: flex;
  gap: 12px;
  flex-direction: column;
  list-style: none;
  padding: 0;
  margin: 0 0 40px 0;
  .trial-feature-item {
    display: flex;
    align-items: center;
    gap: 12px;
    font-weight: var(--typography-font-weight-fw-400);
  }
}
.trial-ended-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  .discount-subscription {
    font-weight: var(--typography-font-weight-fw-600);
    color: var(--color-text-primary-default);
  }
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    .upgrade-button {
      width: 100%;
    }
  }
}
</style>
